import { render, staticRenderFns } from "./flow4.vue?vue&type=template&id=47ac4762&scoped=true&"
import script from "./flow4.vue?vue&type=script&lang=js&"
export * from "./flow4.vue?vue&type=script&lang=js&"
import style0 from "./flow4.vue?vue&type=style&index=0&id=47ac4762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac4762",
  null
  
)

export default component.exports